import React from 'react';
import './App.css';
// import {RaisedButton} from 'material-ui';
import AppBar from 'material-ui/AppBar';
import MainMenu from '../MainMenu';
import LoginLogout from '../LoginLogout';
import MainSearch from '../MainSearch';

// import RaisedButton from 'material-ui/RaisedButton';
// import Toolbar from 'material-ui/Toolbar';
// import DatePicker from 'material-ui/DatePicker';
// import Draggable from 'react-draggable';


class App extends React.PureComponent {
  addProjectHandler = () => {
    this.props.actions.addProject(new Date())
  }
  handleMenuToggle = (state) => {
    if (state !== undefined) {
      this.props.toggleMenu()
    }
  }
  render() {
    const { isMenuExpanded } = this.props;
    return (
      <div>
        <AppBar
          onLeftIconButtonClick={this.handleMenuToggle}
          title='my own dash'
          iconElementRight={<LoginLogout />}
        >
          {/* <MainSearch /> */}
        </AppBar>
        <MainMenu isMenuExpanded={isMenuExpanded} handleMenuToggle={this.handleMenuToggle} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js